// Mobile: any 10-digit number.
// Landline: optional leading 0, area code digit (1-9), then 6-7 more digits (7-9 digits total).
export const PHONE_REGEX = /^\d{10}$|^0?[1-9]\d{6,7}$/;

// Full Nepali phone validation (reference — not used in app):
// Covers +977/00977 country code, mobile prefixes (98/97/91), landlines with
// area code + optional dash, and emergency/hotline numbers (100, 101, 102, 1498, 900).
//
// function validatePhoneNumber(phoneNumber) {
//   const regex =
//     /^(?:(\+|00)?977\s?)?((98\d{8}|97\d{8}|91\d{8})|(0?[1-9]\d{0,1}-?\d{5,7})|(100|101|102|1498|900))$/;
//   return regex.test(phoneNumber);
// }
export const PHONE_REGEX_MESSAGE = "Invalid phone number";
